module.exports = __webpack_public_path__ + "static/media/MojangLogo.e771507d.svg";